import {DATE_BR_REGEX} from '../regex'

export default function dateValidator(value){
  const result = DATE_BR_REGEX.test(value)
  return result
}
